import {
  DeltaDirectionEnum,
  DirectionEnum,
} from 'modules/intelligentInsights/brandAffinityInsights/types';
import { BrandAffinityLevel } from 'modules/domains';

export const HEADER_TITLE = 'Brand Affinity Insights';
export const MAIN_HEADER_TIME_RANGE_TITLE = 'Viewing';

export const NO_BRAND_AFFINITY_DATA_TITLE = 'No Brand Affinity data yet';
export const NO_BRAND_AFFINITY_DATA_BODY =
  'You should expect to see data here in a couple of weeks.';
export const NO_BRAND_AFFINITY_DATA_LINK = 'Learn more by visiting our ';

export const BRAND_AFFINITY_NOT_ENABLED = 'Brand Affinity is not enabled for this project';
export const BRAND_AFFINITY_NOT_ENABLED_LEARN_MORE = 'Learn more by visiting our';
export const BRAND_AFFINITY_NOT_ENABLED_KNOWLEDGE_CENTER = 'Knowledge Center';
export const BRAND_AFFINITY_NOT_ENABLED_CONTACT_CSM =
  ' Contact your CSM if you’d like to enable this feature';

export const AFFINITY_TRENDS_LEFT_TITLE = 'Trends over time';
export const AFFINITY_TRENDS_RIGHT_TITLE = 'View trends by';
export const AFFINITY_TRENDS_TEXTS_BY_DIRECTION = {
  [DeltaDirectionEnum.gain]: {
    dataThresholdText: 'gain',
    title: 'Biggest gain',
    movement: 'increase in',
  },
  [DeltaDirectionEnum.unscored]: {
    dataThresholdText: '',
    title: 'Total Unscored',
    movement: 'users are currently',
  },
  [DeltaDirectionEnum.decline]: {
    dataThresholdText: 'decline',
    title: 'Biggest decline',
    movement: 'decrease in',
  },
};
export const AFFINITY_TRENDS_DELTA_LINK_TEXT = 'More about these users';
export const AFFINITY_TRENDS_DELTA_PERCENT_TEXT = 'percentage point';
export const AFFINITY_TRENDS_GRAPH_PERCENT_TITLE = 'Percentage';
export const AFFINITY_TRENDS_GRAPH_COUNT_TITLE = 'User count';
export const AFFINITY_TRENDS_DELTA_TOGGLE_TIP_TEXT =
  'Unscored users are those who have not received enough messages to generate a meaningful Brand Affinity label';
export const AFFINITY_TREND_CSV_EXPORT_SUCCESS = 'Chart data successfully exported';
export const AFFINITY_TREND_CSV_DIRECTIONS = {
  [DirectionEnum.up]: 'Improved',
  [DirectionEnum.down]: 'Degraded',
};
export const BREAKDOWN_BY_AFFINITY = 'Breakdown by affinity';
export const AFFINITY_BREAKDOWN_ANCHOR = 'breakdownByAffinity';
export const EXPORT_CSV = 'Export CSV';
export const AFFINITY_BREAKDOWN_EXPORT_CONFIG = {
  ENGAGEMENT: {
    ID: 'menu-option-export-engagement',
    TITLE: 'Engagement overview data',
    FILE_NAME: 'Engagement_overview',
    SUCCESS: 'Engagement overview data successfully exported',
  },
  MOVEMENT: {
    ID: 'menu-option-export-movement',
    TITLE: 'User movement data',
    FILE_NAME: 'User_movement',
    SUCCESS: 'User movement data successfully exported',
  },
  CAMPAIGNS: {
    ID: 'menu-option-export-campaigns',
    TITLE: 'Campaign Impact data',
    FILE_NAME: 'Contributing_campaigns',
    SUCCESS: 'Contributing campaigns data successfully exported',
  },
};
export const descriptionsByCohort = {
  [BrandAffinityLevel.LOYAL]:
    'Loyal users are highly engaged with your messages and frequently interact with them',
  [BrandAffinityLevel.POSITIVE]:
    'Positive users are generally engaged with your messages and often interacts with them (but less frequently than Loyal users)',
  [BrandAffinityLevel.NEUTRAL]:
    'Neutral users sometimes engage with your messages and only occasionally interact with them',
  [BrandAffinityLevel.NEGATIVE]:
    'Negative users are usually disengaged with your messages and generally do not interact with them',
  [BrandAffinityLevel.UNSCORED]:
    'Unscored users have not yet received enough messages to generate a meaningful Brand Affinity label',
};

export const AFFINITY_USERS = 'affinity users';
export const VIEW_IN_SEGMENTATION = 'View list in segmentation';
export const ABOUT_YOUR_COHORT_USERS_TEXTS = {
  ABOUT_YOUR: 'About your',
  USERS: 'users',
};
export const CONTRIBUTING_FACTORS = 'Contributing factors';
export const ENGAGEMENT_OVERVIEW = 'Engagement Overview';
export const TOTAL_SENDS = 'Total sends';
export const OPENS = 'Opens';
export const CLICKS = 'Clicks';
export const USER_MOVEMENT = 'User Movement';
export const NEW = 'New';
export const USERS = 'users';
export const RETAINED = 'Retained';
export const USERS_WHO_LEFT = 'Users who left';
export const EXIST_PROJECT = 'Existing project users who recently became';
export const NEW_TO_PROJECT = 'Project users who recently became';
export const CAME_FROM = 'and where they came from';
export const USERS_STAYED = 'Users who have stayed';
export const USERS_MOVED = 'Users who have moved to another affinity and where they went';
export const CONTRIBUTION_TOP_FIVE = 'Top 5 campaign contributors to movement';
export const CONTRIBUTION_BY_CHANNEL = 'Contribution by channel';
export const IMPROVED_TO = 'Improved to';
export const DEGRADED_TO = 'Degraded to';
export const ALL_MOVEMENT = 'All movement';
export const UNSCORED_ANALYTIC_METRICS = {
  totalSends: 'Total sends',
  sendSkips: 'Send skips',
  unsubscribes: 'Unsubscribes',
};
export const CONTRIBUTING_CAMPAIGNS_EMPTY_TEXT =
  'There were no contributing campaigns to this affinity group';
export const CONTRIBUTING_CAMPAIGNS_ERROR_TEXT =
  'Sorry, we’re having trouble loading campaign contributors. Come back again later or';

export const MOVEMENT_NEW_TO_PROJECT = 'New to project';
export const MOVEMENT_DELETED_USERS = 'Deleted users';
export const UNSCORED_UNSUBSCRIBES = 'unsubscribes';
export const UNSCORED_UNSUBSCRIBE_TITLE = 'most unsubscribed channels and message types';
export const UNSCORED_UNSUBSCRIBE_TOOLTIP_NOTICE =
  'This data is based on user-initiated unsubscribes, including Complaint, EmailLink, and ISP unsubscribe events';
export const UNSCORED_UNSUBSCRIBE_EMPTY_TEXT =
  'There were no Unscored unsubscribe channels or message types';
export const UNSCORED_UNSUBSCRIBE_ERROR_TEXT =
  'Sorry, we’re having trouble loading channels and message types. Come back again later or';

export const formatOneDecimalPlaceOption: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
};

export const affinityTabOrder = [
  BrandAffinityLevel.LOYAL,
  BrandAffinityLevel.POSITIVE,
  BrandAffinityLevel.NEUTRAL,
  BrandAffinityLevel.NEGATIVE,
  BrandAffinityLevel.UNSCORED,
];

export const BRAND_AFFINITY_CYCLE_DAYS = 7;

export const ITBLDS_BA_PREFIX = 'itblDS.brandAffinityLabel';
